/* eslint-disable import/no-anonymous-default-export */
import ctx from "../../plugins/axios";
export default async (updateObj) => {
  return await ctx.put("/admin/product_bu", updateObj);
};
